import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

const PowerBIDashboard = ({ reportId, groupId, embedUrl, accessToken, filter }) => {

  const [embedConfig, setEmbedConfig] = useState(null);

  useEffect(() => {
    // Wait until all required values are available
    if (!reportId || !embedUrl || !accessToken) return;

    // Build filter if provided
    let filters = [];
    if (filter && typeof filter === "string") {

      const stripOuterParens = (str) => {
        let s = str.trim();
        while (s.startsWith("(") && s.endsWith(")")) {
          let depth = 0;
          let matchesOuter = true;
          for (let i = 0; i < s.length - 1; i++) {
            if (s[i] === "(") depth++;
            else if (s[i] === ")") depth--;
            if (depth === 0) {
              matchesOuter = false;
              break;
            }
          }
          if (matchesOuter) {
            s = s.slice(1, -1).trim();
          } else {
            break;
          }
        }
        return s;
      };

      // Split into individual filters by 'and'
      const parts = filter.split(/\s+and\s+/i);
      parts.forEach((part) => {
        const cleanPart = stripOuterParens(part);
        if (!cleanPart) return;

        // Check for 'in' operator: Table/Column in (val1, val2, ...) OR Table/Column in val1, val2
        const inMatch = cleanPart.match(/^(\w+)\/(\w+)\s+in\s*(?:\(([^)]+)\)|(.+))$/i);
        if (inMatch) {
          const valueStr = (inMatch[3] || inMatch[4]).trim();
          const rawValues = valueStr.split(",");
          const values = rawValues
            .map((v) => {
              const clean = v.trim().replace(/^['"]|['"]$/g, "");
              const num = Number(clean);
              return clean !== "" && !isNaN(num) ? num : clean;
            })
            .filter((v) => v !== "");

          filters.push({
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
              table: inMatch[1],
              column: inMatch[2],
            },
            operator: "In",
            values: values,
            filterType: models.FilterType.Basic,
          });
          return;
        }

        // Check for 'eq' operator: Table/Column eq value
        const eqMatch = cleanPart.match(/^(\w+)\/(\w+)\s+eq\s+(.+)$/i);
        if (eqMatch) {
          const cleanVal = eqMatch[3].trim().replace(/^['"]|['"]$/g, "");
          const num = Number(cleanVal);
          const parsedVal = cleanVal !== "" && !isNaN(num) ? num : cleanVal;

          filters.push({
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
              table: eqMatch[1],
              column: eqMatch[2],
            },
            operator: "In",
            values: [parsedVal],
            filterType: models.FilterType.Basic,
          });
          return;
        }
      });
    }

    setEmbedConfig({
      type: "report",
      id: reportId,
      embedUrl: embedUrl,
      accessToken: accessToken,
      tokenType: models.TokenType.Embed,
      filters: filters,
      settings: {
        panes: {
          filters: { expanded: false, visible: false },
          pageNavigation: { visible: false },
        },
        background: models.BackgroundType.Transparent,
      },
    });
  }, [reportId, embedUrl, accessToken, filter]);

  if (!embedConfig) {
    return (
      <div className="d-flex justify-content-center align-items-center"
        style={{ height: "500px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <PowerBIEmbed
      embedConfig={embedConfig}
      cssClassName="powerbi-report-iframe"
    />
  );
};

export default PowerBIDashboard;
